import React from 'react';
import { Calendar, Clock, Wrench } from 'lucide-react';

const MaintenanceCalendar = () => {
  // Mock maintenance data
  const upcomingMaintenance = [
    {
      id: 1,
      assetName: "Commercial Refrigerator XL-5000",
      date: "2024-03-15",
      type: "Preventive",
      priority: "high"
    },
    {
      id: 2,
      assetName: "Delivery Van - Toyota HiAce",
      date: "2024-03-18",
      type: "Scheduled",
      priority: "medium"
    },
    {
      id: 3,
      assetName: "Coffee Machine Pro X2",
      date: "2024-03-20",
      type: "Inspection",
      priority: "low"
    }
  ];

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'high':
        return 'text-red-600 bg-red-50';
      case 'medium':
        return 'text-orange-600 bg-orange-50';
      case 'low':
        return 'text-green-600 bg-green-50';
      default:
        return 'text-gray-600 bg-gray-50';
    }
  };

  return (
    <div className="space-y-4">
      {upcomingMaintenance.map((item) => (
        <div
          key={item.id}
          className="p-3 bg-gray-50 rounded-lg flex items-center justify-between"
        >
          <div className="flex items-center gap-3">
            <div className={`p-2 rounded-lg ${getPriorityColor(item.priority)}`}>
              <Wrench className="w-4 h-4" />
            </div>
            <div>
              <h4 className="text-sm font-medium text-gray-900">{item.assetName}</h4>
              <div className="flex items-center gap-2 text-xs text-gray-500">
                <Calendar className="w-3 h-3" />
                {new Date(item.date).toLocaleDateString()}
                <Clock className="w-3 h-3 ml-2" />
                {item.type}
              </div>
            </div>
          </div>
          <button className="text-xs font-medium text-blue-600 hover:text-blue-700">
            View Details
          </button>
        </div>
      ))}
    </div>
  );
};

export default MaintenanceCalendar; 